<template>
  <v-menu top>
    <template v-slot:activator="{ on }">
      <v-btn fab :disabled="disabled" v-on="on">
        <v-icon>mdi-video</v-icon>
      </v-btn>
    </template>

    <v-list dense>
      <template v-if="videoDevices.length > 1">
        <v-subheader class="px-2 overline">Video source</v-subheader>
        <v-list-item-group v-model="videoDeviceI">
          <v-list-item v-for="(item, i) in videoDevices" :key="i" @click="">
            <template v-slot:default="{ active, toggle }">
              <v-list-item-action>
                <v-checkbox v-model="active" @click="toggle" />
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{item.label}}</v-list-item-title>
              </v-list-item-content>
            </template>
          </v-list-item>
        </v-list-item-group>
      </template>
      <template v-if="audioDevices.length > 1">
      <v-subheader class="px-2 overline">Audio source</v-subheader>
        <v-list-item-group v-model="audioDeviceI">
          <v-list-item v-for="(item, i) in audioDevices" :key="i" @click="">
            <template v-slot:default="{ active, toggle }">
              <v-list-item-action>
                <v-checkbox v-model="active" @click="toggle" />
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{item.label}}</v-list-item-title>
              </v-list-item-content>
            </template>
          </v-list-item>
        </v-list-item-group>
      </template>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: 'media-source-menu',
  props: [ 'disabled' ],
  data() {
    return {
      videoDeviceI: null,
      videoDevices: [],
      audioDeviceI: null,
      audioDevices: []
    };
  },
  computed: {
    async stream() {
      if (this.audioDeviceI === null || this.videoDeviceI === null) {
        return null;
      }
      return await navigator.mediaDevices.getUserMedia({
        audio: { deviceId: { exact: this.audioDevices[this.audioDeviceI].deviceId } },
        video: { deviceId: { exact: this.videoDevices[this.videoDeviceI].deviceId } }
      });
    }
  },
  async mounted() {
    // This call will prompt the user for access to the camera and microphone. It is important to make this call
    // first, so that the call to 'enumerateDevices' returns the correct labels.
    await navigator.mediaDevices.getUserMedia({ audio: {}, video: {} });

    const mediaDevices = await navigator.mediaDevices.enumerateDevices();
    this.videoDevices = [];
    this.audioDevices = [];
    const defaults = {};
    for (let mediaDevice of mediaDevices) {
      if (mediaDevice.deviceId === 'default') {
        defaults[mediaDevice.groupId] = true;
        continue;
      }
      if (mediaDevice.kind === 'videoinput') {
        this.videoDevices.push(mediaDevice);
      } else if (mediaDevice.kind === 'audioinput') {
        this.audioDevices.push(mediaDevice);
      }
    }

    this.videoDeviceI = null;
    for (let i = 0; i < this.videoDevices.length; i++) {
      if (this.videoDeviceI === null || defaults[this.videoDevices[i].groupId]) {
        this.videoDeviceI = i;
      }
    }

    this.audioDeviceI = null;
    for (let i = 0; i < this.audioDevices.length; i++) {
      if (this.audioDeviceI === null || defaults[this.audioDevices[i].groupId]) {
        this.audioDeviceI = i;
      }
    }
  },
  watch: {
    stream: {
      immediate: true,
      async handler(streamPromise) {
        this.$emit('change', await streamPromise);
      }
    }
  }
}
</script>
